import './Beta.scss';

export const Beta = () => {
    return (
        <div  className='beta'>
            BETA
        </div>
    );
};
